import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subcategoryField"]

  connect() {
    this.toggleSubcategory()
  }

  toggleSubcategory() {
    const categorySelect = this.element.querySelector('select[name="product[category]"]')
    const subcategoryField = this.subcategoryFieldTarget
    
    if (categorySelect.value === 'material') {
      subcategoryField.classList.remove('hidden')
    } else {
      subcategoryField.classList.add('hidden')
    }
  }
}
